export const menuItems = [
  {
    path: "/",
    text: "home",
  },
  {
    path: "/voli",
    text: "voli",
  },
  {
    path: "/decolli",
    text: "decolli",
  },
  {
    path: "/news",
    text: "news",
  },
  {
    path: "/contact",
    text: "contatti",
  },
]
